import axios from 'axios';
import config from '../config';

const instanceWD = axios.create({
  baseURL: config.baseURLWD,
  //withCredentials: true
});

export {instanceWD};
